<template>
  <div>
    <div v-if="'isReviewFirst' in reviewStore.settings" class="my-4">
      <div v-if="reviewStore.settings.thankYouImageUrl">
        <img class="h-20 mx-auto object-contain" :src="reviewStore.settings.thankYouImageUrl" alt="Law Logo">
      </div>
      <h2 class="my-4">
        {{ reviewStore.settings.thankYouMessage }}
      </h2>
      <div v-if="!reviewStore.feedbackSubmitted && reviewStore.settings.captureFinalFeedback">
        <input class="w-1/2 p-2 my-4 text-white" v-model="feedbackMessage" type="text" placeholder="Any final thoughts?">
        <div class="flex justify-center">
          <el-button plain type="success" size="large" class="w-1/4 my-4" @click="handlefinalFeedback">
            <transition name="fade" mode="out-in">
              <div :key="submitMessage">
                {{ submitMessage }}
              </div>
            </transition>
          </el-button>
        </div>
      </div>
      <h3> {{ reviewStore.settings.companyEmail }} </h3>
      <h3>{{ reviewStore.settings.phoneNumber }}</h3>
      <h3>{{ reviewStore.settings.address }}</h3>
    </div>
    <div v-else>
      <h2 class="my-4">
        Something may be wrong with your link. Please contact the company directly or reach out to HeroGrow at the
        information below.
      </h2>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useReview } from "@/stores";
const reviewStore = useReview();

const submitMessage = ref("Submit Feedback");
const feedbackMessage = ref("");

const handlefinalFeedback = () => {
  reviewStore.updateFeedback(feedbackMessage.value);
  submitMessage.value = "Feedback Submitted";
}

</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}
</style>